<template>
    <div class="component-container">
        <div class="chart-canvas" id="single"></div>
        <img class="banner" src="@/assets/images/bg-pic.png" alt="" />
    </div>
</template>

<script>
import * as echarts from "echarts";

import { mapState } from "vuex";
export default {
    data () {
        return {
            goodsType: [], //商品类型列表
            retailPurchase: [], //进货量列表
            outPurchase: [], //出货量列表
            startVal: 0, //区域缩放的起点值
            endVal: 3, //区域缩放的起点值
            timeId: null, //定时器的id

            myChart: undefined
        };
    },
    async mounted () {
        this.initChart();
    },
    computed: {
        ...mapState(["dateType"]),
    },
    watch: {
        dateType (newVal, oldVal) {
            if (newVal !== oldVal) {
                this.getData();
            }
        },
    },
    destroyed () {
        //清除定时器
        clearInterval(this.timeId);
    },
    methods: {
        // 初始化表
        async initChart () {
            const chartDom = document.getElementById("single");
            this.myChart = echarts.init(chartDom);
            await this.getData();
            this.startInterval();
            this.myChart.on("mouseover", () => {
                clearInterval(this.timeId);
            });
            this.myChart.on("mouseout", () => {
                this.startInterval();
            });
        },
        //获取后台的数据
        async getData () {
            await this.$http
                .get("/screen/getGoodsCargoVolume?type=" + this.dateType, {})
                .then((response) => {
                    // console.log(response);
                    if (response.data.resultCode == 200) {
                        this.goodsType = [];
                        this.retailPurchase = [];
                        this.outPurchase = [];
                        const inList = response.data.inList;
                        const outList = response.data.outList;
                        const categorySet = new Set(); // 分类集合
                        inList.forEach((element) => {
                            categorySet.add(element.goods_id); // 将进货分类id抽出来
                            this.goodsType.push(element.goods_name);
                            // console.log(element.goods_name);
                        });
                        outList.forEach((element) => {
                            categorySet.add(element.category_id); // 将出货分类id抽出来
                        });

                        // 把set转成array
                        const categoryIds = Array.from(categorySet);

                        const inListValue = new Array(categoryIds.length).fill(0); // 进货量数组
                        const outListValue = new Array(categoryIds.length).fill(0); // 进货量数组

                        const categoryName = new Array(categoryIds.length).fill(0); // 分类名称

                        inList.forEach((element) => {
                            inListValue[categoryIds.indexOf(element.goods_id)] =
                                element.net_weight / 1000;
                            categoryName[categoryIds.indexOf(element.goods_id)] =
                                element.goods_name;
                        });
                        outList.forEach((element) => {
                            outListValue[categoryIds.indexOf(element.category_id)] =
                                element.weight;
                        });
                        // 渲染进货量
                        this.retailPurchase = inListValue;
                        // console.log(this.retailPurchase);
                        // 渲染出货量
                        this.outPurchase = outListValue;
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
            this.startVal = 0
            this.endVal = 3
            this.showEcharts();
        },
        showEcharts () {
            const option = {
                title: {
                    text: "单品种净重排名",
                    left: "17",
                    top: "6",
                    textStyle: {
                        color: "#00C4FF",
                    },
                },
                tooltip: {
                    show: true,
                    // formatter: '{b}:  {c}t'
                },
                // legend: {
                //     data: ["进货量", "出货量"],
                //     top: 35,
                //     icon: "circle",
                //     textStyle: {
                //         //图例文字的样式
                //         color: "#0CFEEE",
                //         fontSize: 20,
                //     },
                // },
                toolbox: {
                    show: true,
                    feature: {},
                },
                grid: {
                    left: "14%",
                    right: "4%",
                    bottom: "18%",
                    top: "30%",
                },
                calculable: true,
                xAxis: [
                    {
                        type: "category",
                        data: this.goodsType,
                        axisLabel: {
                            show: true,
                            textStyle: {
                                color: "#fff", //x轴的刻度线颜色
                                fontSize: 18,
                                marginTop: 1500
                            },
                        },
                        offset: 12,
                        nameTextStyle: {
                            color: "#0CFEEE", //坐标轴name颜色
                            fontSize: 18,
                        },
                        axisTick: {
                            alignWithLabel: true,
                        },
                        axisLine: {
                            show: false,
                            lineStyle: {
                                color: '#82b0ec',
                            },
                        },
                    },
                ],
                yAxis: [
                    {
                        type: "value",
                        splitLine: false,
                        name: "重量(吨)",
                        axisLabel: {
                            show: true,
                            textStyle: {
                                color: "#fff", //y轴的刻度线颜色
                                fontSize: 16,
                            },
                        },
                        nameTextStyle: {
                            color: "#0CFEEE", //坐标轴name颜色
                            fontSize: 17,
                        },
                    },
                ],
                dataZoom: {
                    show: false,
                    startValue: this.startVal,
                    endValue: this.endVal,
                },
                series: [
                    {
                        name: '',
                        type: 'pictorialBar',
                        symbolSize: [40, 10],
                        symbolOffset: [0, -6], // 上部椭圆
                        symbolPosition: 'end',
                        z: 12,
                        // "barWidth": "0",
                        label: {
                            normal: {
                                show: true,
                                position: 'top',
                                // "formatter": "{c}%"
                                fontSize: 15,
                                fontWeight: 'bold',
                                color: '#34DCFF',
                            },
                        },
                        color: '#2DB1EF',
                        data: this.retailPurchase,
                    },
                    {
                        name: '',
                        type: 'pictorialBar',
                        symbolSize: [40, 10],
                        symbolOffset: [0, 7], // 下部椭圆
                        // "barWidth": "20",
                        z: 12,
                        color: '#2DB1EF',
                        data: this.retailPurchase,
                    },
                    {
                        name: '',
                        type: 'pictorialBar',
                        symbolSize: function (d) {
                            return d > 0 ? [50, 15] : [0, 0]
                        },
                        symbolOffset: [0, 14], // 下部内环
                        z: 10,
                        itemStyle: {
                            normal: {
                                color: 'transparent',
                                borderColor: '#2db1ef',
                                borderType: 'solid',
                                borderWidth: 10,
                            },
                        },
                        data: this.retailPurchase,
                    },
                    {
                        name: '',
                        type: 'pictorialBar',
                        symbolSize: [70, 20],
                        symbolOffset: [0, 18], // 下部外环
                        z: 10,
                        itemStyle: {
                            normal: {
                                color: 'transparent',
                                borderColor: '#2db1ef',
                                borderType: 'solid',
                                borderWidth: 10,
                            },
                        },
                        data: this.retailPurchase,
                    },
                    {
                        type: 'bar',
                        //silent: true,
                        barWidth: '40',
                        barGap: '10%', // Make series be overlap
                        barCateGoryGap: '10%',
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 0.7, [
                                    {
                                        offset: 0,
                                        color: '#38B2E6',
                                    },
                                    {
                                        offset: 1,
                                        color: '#0B3147',
                                    },
                                ]),
                                opacity: 0.8,
                            },
                        },
                        data: this.retailPurchase,
                    },
                    // {
                    //     name: "进货量",
                    //     type: "bar",
                    //     barWidth: 15, //柱子宽度
                    //     data: this.retailPurchase,
                    //     // color: "#00FFE7",
                    //     itemStyle: {
                    //         color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    //             { offset: 0, color: '#83bff6' },
                    //             { offset: 0.5, color: '#188df0' },
                    //             { offset: 1, color: '#188df0' }
                    //         ])
                    //     },
                    //     emphasis: {
                    //         itemStyle: {
                    //             color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    //                 { offset: 0, color: '#2378f7' },
                    //                 { offset: 0.7, color: '#2378f7' },
                    //                 { offset: 1, color: '#83bff6' }
                    //             ])
                    //         }
                    //     },
                    //     // itemStyle: {
                    //     //     barBorderRadius: [10, 10, 10, 10],
                    //     // },
                    //     markPoint: {},
                    // },
                    // {
                    //     name: "出货量",
                    //     type: "bar",
                    //     barWidth: 15, //柱子宽度
                    //     barGap: "0%",
                    //     itemStyle: {
                    //         normal: {
                    //             barBorderRadius: [10, 10, 10, 10],
                    //             color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    //                 {
                    //                     offset: 0,
                    //                     color: "#ba7ef3",
                    //                 },
                    //                 {
                    //                     offset: 1,
                    //                     color: "#965df2",
                    //                 },
                    //             ]),
                    //         },
                    //     },
                    //     data: this.outPurchase,
                    // },
                ],
            };
            option && this.myChart.setOption(option);
            this.myChart.resize()
        },
        startInterval () {
            // 判断定时器是否存在
            if (this.timeId) {
                clearInterval(this.timeId);
            }
            this.timeId = setInterval(() => {
                this.startVal++;
                this.endVal++;
                if (this.endVal > this.goodsType.length - 1) {
                    this.startVal = 0;
                    this.endVal = 3;
                }
                this.showEcharts();
            }, 5000);
        },
    },
};
</script>

<style scoped>
</style>
